module.exports = __webpack_public_path__ + "img/switch-softinya.2508aeb7.png";